import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

import styles from 'src/pages/landlord/leads/messages/LeadMessagesPage.module.css';

type Props = {
    isAssigningLead: boolean;
    onAssignToSelf: () => void;
};

/**
 * Shown for a lead the current user cannot reply to: either the team-availability
 * feature is off, or it is on but the owner is currently online. Offers to assign
 * the lead to the current user so they can reply.
 */
export default function CannotReplyNotice({ isAssigningLead, onAssignToSelf }: Props) {
    return (
        <div className={styles.noticeBarOuter}>
            <div className={`${styles.noticeBarInner} ${styles.noticeBarOnline}`}>
                <div className={styles.noticeBarSubtitle}>
                    This lead does not belong to you so you cannot send a reply.
                </div>
                <LoadingButton
                    variant="outlined"
                    color="warning"
                    size="small"
                    loading={isAssigningLead}
                    onClick={onAssignToSelf}
                    className={styles.noticeBarButton}
                    data-testid="assign-lead-to-self-button"
                >
                    Assign to myself
                </LoadingButton>
            </div>
        </div>
    );
}
